import React , {useRef , useState , useEffect} from "react";
import '../index.css';
import Footer from "./footer";
import Navbar from "./navbar";
import "../css/checkout.css";
import "../css/cart.css"
import baseUrl from "../base_url";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// import axios from "axios";
import axios from "./components/customAxios.js"
import Loader from "./home_components/loader";
import { Navigate } from "react-router-dom";
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';

function MainContentBanner(props) {
    const styles = {
        width: "100%",
        minWidth: "100%",
        height: "32px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "12px",
        fontWeight: 500,
    }

    return (
        <div style={styles} className="MainContentBanner">
            <p>HM.com / <span style={{ color: "red", fontSize: "15px", paddingLeft: "5px", fontWeight: "600" }} className="red">Checkout</span> </p>
        </div>
    )
}

function CartRight({ step, price, checkoutData }) {
    const navigate = useNavigate();
    const [value, setValue] = useState(price);
    const [orderLoading, setOrderLoading] = useState(false);
    const [paymentError, setPaymentError] = useState(null);
    const [userData, setUserData] = useState({});
    
    
    // Fetch cart data
    useEffect(() => {
        const checkCart = async () => {
            try {
                const response = await axios.get(`${baseUrl}api/cart/get-cart`, { withCredentials: true });
                setValue(response.data.data.value)
        

            } catch (err) {
                console.error("Error while checking cart status:", err.response?.data || err.message);
            }
        };

        checkCart();
    }, []);

    

    // Fetch user data
    useEffect(() => {
        const getUserData = async () => {
            try {
                const response = await axios.get(`${baseUrl}api/user/profile`, { 
                    withCredentials: true 
                });
                setUserData(response?.data?.data);
            } catch (err) {
                console.error("Error while retrieving user data:", err.response?.data || err.message);
                navigate("/");
            }
        };

        getUserData();
    }, []);
    // console.log(checkoutData)
    // Secure payment initialization
async function handlePayment() {
    setOrderLoading(true);
    setPaymentError(null);
    
    try {
        // Check payment method
        if (checkoutData.paymentMethod === "COD") {
            // Handle Cash on Delivery
            const orderResponse = await axios.post(
                `${baseUrl}api/orders/create-cod`, 
                checkoutData.selectedBillingAddress,
                { withCredentials: true }
            );
            
            if (!orderResponse.data.success) {
                throw new Error(orderResponse.data.message || "Failed to create COD order");
            }
            
            // Navigate to success page directly for COD
            navigate("/ordered_successfully");
            return;
        }
        
        // Continue with Razorpay flow for online payment
        const orderResponse = await axios.post(
            `${baseUrl}api/payment/create`, 
            checkoutData.selectedBillingAddress,
            { withCredentials: true }
        );
        
        if (!orderResponse.data.success) {
            throw new Error(orderResponse.data.message || "Failed to create order");
        }
        
        const { orderId, amount, currency, key } = orderResponse.data.data;
        
        // Configure Razorpay with order data from server
        const paymentOptions = {
            key: key,
            amount: amount,
            currency: currency,
            name: "Jutexx",
            description: "Complete your purchase",
            order_id: orderId,
            handler: async function(response) {
                await verifyPayment(
                    response.razorpay_order_id,
                    response.razorpay_payment_id,
                    response.razorpay_signature
                );
            },
            prefill: {
                name: `${userData?.name || ''} ${userData?.surname || ''}`.trim(),
                email: userData?.email,
                contact: checkoutData?.deliveryData?.number || userData?.phoneNumber
            },
            notes: {
                address: checkoutData?.selectedBillingAddress ? 
                    `${checkoutData.selectedBillingAddress.streetAddress}, ${checkoutData.selectedBillingAddress.city}` : 
                    ''
            },
            theme: {
                color: "#3399cc"
            },
            modal: {
                ondismiss: function() {
                    setOrderLoading(false);
                }
            }
        };

        // Initialize and open Razorpay
        const razorpay = new window.Razorpay(paymentOptions);
        
        razorpay.on("payment.failed", function(response) {
            setPaymentError(response.error.description || "Payment failed");
            setOrderLoading(false);
        });

        razorpay.open();
    } catch (error) {
        console.error("Payment initiation failed:", error);
        setPaymentError(error.message || "Payment initiation failed");
        setOrderLoading(false);
    }
}

    // Verify payment with server after Razorpay callback
    async function verifyPayment(orderId, paymentId, signature) {
        try {
            const response = await axios.post(
                `${baseUrl}api/payment/verify`, 
                {
                    orderId,
                    paymentId,
                    signature
                }, 
                { withCredentials: true }
            );
            
            if (response.data.success) {
                navigate("/ordered_successfully");
            } else {
                setPaymentError("Payment verification failed");
                setOrderLoading(false);
            }
        } catch (error) {
            console.error("Payment verification failed:", error);
            setPaymentError(error.response?.data?.message || "Payment verification failed");
            setOrderLoading(false);
        }
    }

    return (
        <div className="cart_info_right rightCheckout">
            <div className="proceed">
                <div className="proceed_abv">
                    <span>
                        <p>Order value</p>
                        <p>Rs. {value}</p>
                    </span>
                    <span>
                        <p>Delivery</p>
                        <p>FREE</p>
                    </span>
                </div>
                <div className="proceed_btm">
                    <span>
                        <p>Total</p>
                        <p>Rs. {value}</p>
                    </span>
                    {step < 4 && <button className="disabled">Fill Details to Proceed </button>}
                {step === 4 && 
                    <>
                        {!orderLoading && (
                            <button 
                                onClick={handlePayment}
                                disabled={orderLoading}
                                className="payment-btn"
                            >
                                {checkoutData.paymentMethod === "COD" ? "Place Order (COD)" : "Pay and Order Now"}
                            </button>
                        )}
                        {orderLoading && <div className="ATC"><Loader/></div>}
                        {paymentError && (
                            <div className="payment-error">
                                {paymentError}
                            </div>
                        )}
                    </>
                }
                </div>
                <div className="checkout_info">
                    <p>We accept</p>
                    <div className="payment_infos">
                        {/* Payment icons */}
                    </div>
                    <div className="secure-payment-note">
                        <p>🔒 Your payment information is processed securely.</p>
                    </div>
                    <p className="disclaimer_p">
                        Prices and delivery costs are not confirmed until you've reached the checkout.
                        15 days free returns. Read more about return and refund policy.
                        Customers would receive an SMS/WhatsApp notification regarding deliveries on the registered phone number.
                    </p>
                </div>
            </div>
        </div>
    );
}



function MyInfo(props) {
  const emailRef = useRef(null);
  const nameRef = useRef(null);
  const surnameRef = useRef(null);
  
  const [errors, setErrors] = useState({
    email: "",
    name: "",
    surname: ""
  });
  
  const [touched, setTouched] = useState({
    email: false,
    name: false,
    surname: false
  });

  var styles = {};
  if (props.step === 1) {
    styles = {
      maxHeight: "max-content"
    };
  } else if (props.step > 1) {
    styles = {
      maxHeight: "120px",
    };
  }
  
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleBlur = (field) => {
    setTouched(prev => ({
      ...prev,
      [field]: true
    }));
    
    validateField(field);
  };
  
  const validateField = (field) => {
    const newErrors = { ...errors };
    
    switch (field) {
      case "email":
        const email = emailRef.current.value;
        if (!email.trim()) {
          newErrors.email = "Email is required";
        } else if (!validateEmail(email)) {
          newErrors.email = "Please enter a valid email address";
        } else {
          newErrors.email = "";
        }
        break;
      case "name":
        const name = nameRef.current.value;
        if (!name.trim()) {
          newErrors.name = "First name is required";
        } else {
          newErrors.name = "";
        }
        break;
      case "surname":
        const surname = surnameRef.current.value;
        if (!surname.trim()) {
          newErrors.surname = "Last name is required";
        } else {
          newErrors.surname = "";
        }
        break;
      default:
        break;
    }
    
    setErrors(newErrors);
  };
  
  const validateAll = () => {
    const email = emailRef.current.value;
    const name = nameRef.current.value;
    const surname = surnameRef.current.value;
    
    const newErrors = {
      email: !email.trim() ? "Email is required" : 
             !validateEmail(email) ? "Please enter a valid email address" : "",
      name: !name.trim() ? "First name is required" : "",
      surname: !surname.trim() ? "Last name is required" : ""
    };
    
    setErrors(newErrors);
    setTouched({email: true, name: true, surname: true});
    
    return !newErrors.email && !newErrors.name && !newErrors.surname;
  };

  function handleClick() {
    if (validateAll()) {
      const email = emailRef.current.value;
      const name = nameRef.current.value;
      const surname = surnameRef.current.value;

      props.setinfo({ email, name, surname });
      props.setStep((prev) => prev + 1);
    }
  }

  return (
    <div style={styles} className="my_info checkout_details_div">
      <p className="checkout_info_labels">My information</p>

      {props.step > 1 && (
        <span>
          <p className="smol">{props.myinfo_data.email}</p>
          <p className="smol">{props.myinfo_data.name} {props.myinfo_data.surname}</p>
        </span>
      )}

      <p className="label">Email*</p>
      <input
        className={`border-[1px] rounded-[5px] ${touched.email && errors.email ? "border-red-500" : ""}`}
        ref={emailRef}
        name="email"
        type="email"
        placeholder=""
        onBlur={() => handleBlur("email")}
      />
      {touched.email && errors.email && (
        <p className="text-red-500 text-xs mt-1">{errors.email}</p>
      )}

      <div className="name_input_area">
        <span>
          <p className="label">First Name*</p>
          <input
            className={`border-[1px] rounded-[5px] ${touched.name && errors.name ? "border-red-500" : ""}`}
            ref={nameRef}
            name="name"
            type="text"
            placeholder=""
            onBlur={() => handleBlur("name")}
          />
          {touched.name && errors.name && (
            <p className="text-red-500 text-xs mt-1">{errors.name}</p>
          )}
        </span>
        <span>
          <p className="label">Last Name*</p>
          <input
            className={`border-[1px] rounded-[5px] ${touched.surname && errors.surname ? "border-red-500" : ""}`}
            ref={surnameRef}
            name="surname"
            type="text"
            placeholder=""
            onBlur={() => handleBlur("surname")}
          />
          {touched.surname && errors.surname && (
            <p className="text-red-500 text-xs mt-1">{errors.surname}</p>
          )}
        </span>
      </div>
      <span className="toCenter">
        <button onClick={handleClick} className="ATC checkout_buttons_in_same_page">Save</button>
      </span>
    </div>
  );
}

function BillingAddress(props) {
    
    const [loading, setLoading] = React.useState(true);
    const [selectedAddress, setSelectedAddress] = React.useState(null);
    const [showNewAddressForm, setShowNewAddressForm] = React.useState(false);
    const [billing_data, setInfo] = React.useState({
        houseNumber: "",
        address: "",
        city: "",
        pincode: "",
        state: "",
        phone : ""
    });

    // Fetch user data to get saved addresses
    React.useEffect(() => {
        const getUserData = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${baseUrl}api/user/profile`, { withCredentials: true });
                props.setUserData(response?.data?.data);
                
                // If user has addresses and none is selected yet, select the first one by default
                if (response?.data?.data?.address?.length > 0 && !selectedAddress) {
                    setSelectedAddress(response.data.data.address[0]);
                    // console.log(selectedAddress)
                    // If no saved addresses, show the new address form automatically
                } else if (!response?.data?.data?.address || response?.data?.data?.address.length === 0) {
                    setShowNewAddressForm(true);
                }
            } catch (err) {
                console.error("Error while retrieving user data:", err.response?.data || err.message);
            } finally {
                setLoading(false);
            }
        };

        getUserData();
    }, []);

    // Pass billing data to CartRight through props
    React.useEffect(() => {
        // Update the parent component with billing data
        props.setBillingData(billing_data);
    }, [billing_data]);

    // Pass selected address to CartRight when it changes
    React.useEffect(() => {
        if (selectedAddress) {
            props.setSelectedBillingAddress(selectedAddress);
        }
    }, [selectedAddress]);

    function handleChange(e) {
        setInfo((prev) => {
            return {
                ...prev, [e.target.name]: e.target.value
            };
        });
    }

    function handleAddressSelect(address) {
        setSelectedAddress(address);
        setShowNewAddressForm(false);
    }

    function handleAddNewClick() {
        setSelectedAddress(null);
        setShowNewAddressForm(true);
    }

    async function handleSaveNewAddress() {
        // Here you would typically save the new address to the user profile
        // For now, we'll just use it for the checkout process
        const newAddress = {
            houseNumber : billing_data.houseNumber,
            streetAddress: billing_data.address,
            city: billing_data.city,
            postalCode: billing_data.pincode,
            state: billing_data.state,
            fullName : props.myinfo_data.name,
            phone : billing_data.phone,
            country : "India"
        };
        

        try{
            const response = await axios.post(
                `${baseUrl}api/user/profile/add-address`, 
                newAddress, 
                { withCredentials: true }
            );
            // console.log(response)
        }catch(err){
            console.log("error while adding new address")
            console.log(err)
        }

        
        setSelectedAddress(newAddress);
        setShowNewAddressForm(false);
        props.setStep((prev) => prev + 1);
    }

    function handleContinueWithSelected() {
        props.setStep((prev) => prev + 1);
    }

    var styles = {};
    if (props.step === 2) {
        styles = {
            maxHeight: "max-content"
        };
    } else if (props.step > 2) {
        styles = {
            maxHeight: "140px",
        };
    }

    return (
        <div style={styles} className="billing_address checkout_details_div">
            <p className="checkout_info_labels">Billing address</p>

            {props.step > 2 && selectedAddress && (
                <span>
                    <p className="smol">{selectedAddress.fullName || selectedAddress.name || ""}</p>
                    <p className="smol">{selectedAddress.houseNumber || selectedAddress.houseNumber || ""}</p>
                    <p className="smol">{selectedAddress.streetAddress || selectedAddress.address || ""}</p>
                    <p className="smol">{selectedAddress.city || ""} {selectedAddress.postalCode || selectedAddress.pincode || ""}</p>
                    <p className="smol">{selectedAddress.state || ""}</p>
                </span>
            )}

            {props.step === 2 && !loading && (
                <>
                    {/* Address Selection Section */}
                    {props.userData?.address && props.userData.address.length > 0 && !showNewAddressForm && (
                        <div className="saved-addresses">
                            <p className="label mb-3">Select a saved address:</p>
                            <div className="address-list">
                                {props.userData.address.map((address, index) => (
                                    <div 
                                        key={index} 
                                        className={`address-item ${selectedAddress === address ? 'selected-address' : ''}`}
                                        onClick={() => handleAddressSelect(address)}
                                        style={{
                                            padding: "10px",
                                            border: "1px solid #ddd",
                                            borderRadius: "4px",
                                            marginBottom: "8px",
                                            cursor: "pointer",
                                            backgroundColor: selectedAddress === address ? "#f0f0f0" : "white",
                                            fontSize : "14px"
                                        }}
                                    >
                                        <p>{address.fullName}</p>
                                        <p>{address.houseNumber}</p>
                                        <p>{address.streetAddress}</p>
                                        <p>{address.city}, {address.state} {address.postalCode}</p>
                                        <p>Phone: {address.phone}</p>
                                    </div>
                                ))}
                            </div>
                            <button 
                                onClick={handleAddNewClick}
                                className="ATC checkout_buttons_in_same_page"
                                style={{ marginTop: "10px", marginRight: "10px" }}
                            >
                                Add New Address
                            </button>
                            {selectedAddress && (
                                <button 
                                    onClick={handleContinueWithSelected}
                                    className="ATC checkout_buttons_in_same_page"
                                    style={{ marginTop: "10px" }}
                                >
                                    Continue with Selected
                                </button>
                            )}
                        </div>
                    )}

                    {/* New Address Form Section */}
                    {(showNewAddressForm || !props.userData?.address || props.userData.address.length === 0) && (
                        <>
                            <p className="label">Flat/House/Apartment</p>
                            <input className="border-[1px] rounded-[5px]" onChange={handleChange} name="houseNumber" type="text" placeholder="" value={billing_data.houseNumber}></input>

                            <p className="label">Area*</p>
                            <input className="border-[1px] rounded-[5px]" onChange={handleChange} name="address" type="text" placeholder="" value={billing_data.address}></input>      

                            <div className="name_input_area">
                                <span>
                                    <p className="label">Town/City</p>
                                    <input className="border-[1px] rounded-[5px]" onChange={handleChange} name="city" type="text" placeholder="" value={billing_data.city}></input>
                                </span>
                                <span>
                                    <p className="label">Pincode</p>
                                    <input className="border-[1px] rounded-[5px]" onChange={handleChange} name="pincode" type="text" placeholder="" value={billing_data.pincode}></input>
                                </span>
                            </div>
                            <p className="label">State*</p>
                            <input className="border-[1px] rounded-[5px]" onChange={handleChange} name="state" type="text" placeholder="" value={billing_data.state}></input>
                            
                            <p className="label">Phone*</p>
                            <input className="border-[1px] rounded-[5px]" onChange={handleChange} name="phone" type="number" placeholder="" value={billing_data.phone}></input>

                            {props.userData?.address && props.userData.address.length > 0 && (
                                <button 
                                    onClick={() => setShowNewAddressForm(false)}
                                    className="ATC checkout_buttons_in_same_page"
                                    style={{ marginTop: "10px", marginRight: "10px" }}
                                >
                                    Back to Saved Addresses
                                </button>
                            )}
                            
                            <span className="toCenter">
                                <button 
                                    onClick={handleSaveNewAddress} 
                                    className="ATC checkout_buttons_in_same_page"
                                    disabled={!billing_data.address || !billing_data.state}
                                >
                                    Save and Continue
                                </button>
                            </span>
                        </>
                    )}
                </>
            )}

            {props.step === 2 && loading && (
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <p>Loading addresses...</p>
                </div>
            )}
        </div>
    );
}

function Delivery(props){
    const [delivery, setinfo] = React.useState({
        number: ""
    });
    
    // Add validation state
    const [validation, setValidation] = React.useState({
        number: {
            isValid: true,
            errorMessage: ""
        }
    });

    function handleChange(e){
        const { name, value } = e.target;
        
        setinfo((prev)=>{
            return{
                ...prev, [name]: value
            }
        });
        
        // Reset validation on change
        setValidation(prev => ({
            ...prev,
            [name]: { isValid: true, errorMessage: "" }
        }));
    }

    // Pass delivery data to CartRight
    React.useEffect(() => {
        props.setDeliveryData(delivery);
    }, [delivery]);

    var styles = {};
    if(props.step === 3){
        styles = {
            maxHeight: "max-content"
        }
    }else if(props.step > 3){
        styles = {
            maxHeight: "120px",
        } 
    }
    
    function validatePhoneNumber(phoneNumber) {
        // Basic phone number validation
        const phoneRegex = /^[0-9]{10,10}$/;
        return phoneRegex.test(phoneNumber);
    }
    
    function handleClick(){
        // Validate before proceeding
        const isPhoneValid = validatePhoneNumber(delivery.number);
        
        if (!isPhoneValid) {
            setValidation({
                number: {
                    isValid: false,
                    errorMessage: "Please enter a valid phone number (10 digits)"
                }
            });
            return;
        }
        
        // Proceed if validation passes
        props.setStep((prev)=>prev+1)
    }

    return(
        <div style={styles} className="delivery checkout_details_div">
            <p className="checkout_info_labels">Delivery</p>

            {props.step > 3 && <span>
                <p className="smol">Delivery in 2-4 days</p>
                <p className="smol">Phone No. : {delivery.number}</p>
                <br></br>
            </span>}

            {props.step === 3 && (
                <>
                    <p className="label">Phone No.</p>
                    <input 
                        className={`border-[1px] rounded-[5px] ${!validation.number.isValid ? "border-red-500" : ""}`} 
                        onChange={handleChange} 
                        name="number" 
                        type="text" 
                        placeholder="Enter your phone number"
                    />
                    {!validation.number.isValid && (
                        <p className="text-red-500 text-sm mt-1">{validation.number.errorMessage}</p>
                    )}
                    <span className="toCenter">
                        <button onClick={handleClick} className="ATC checkout_buttons_in_same_page">Save</button>                    
                    </span>
                </>
            )}
        </div>
    );
}

function PaymentOption(props) {
    const [method, setMethod] = React.useState("RazorPay");

    function handleChange(e) {
        setMethod(e.target.value);
        // Pass the selected payment method to parent component
        props.setPaymentMethod(e.target.value);
    }

    var styles = {};
    if (props.step === 4) {
        styles = {
            maxHeight: "max-content"
        }
    } else if (props.step > 4) {
        styles = {
            maxHeight: "120px",
        } 
    }

    return (
        <div style={styles} className="payment_option checkout_details_div">
            <p className="checkout_info_labels">Payment Option</p>

            {props.step > 4 && (
                <span>
                    <p className="smol">Payment Option Selected: {method}</p>
                    <br></br>
                </span>
            )}

            {props.step === 4 && (
                <>
                    {/* <p className="label">Payment Method</p>
                    <select 
                        className="border-[1px] rounded-[5px] p-[4px] mt-[5px] outline-none w-[100%]" 
                        onChange={handleChange} 
                        name="method"
                        value={method}
                    >
                        <option value="RazorPay">Online Payment</option>
                        <option value="COD">Cash On Delivery</option>
                    </select> */}

                    <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Method</InputLabel>
                    <Select
                        labelId="method"
                        id="demo-simple-select"
                        value={method}
                        label="method"
                        onChange={handleChange}
                    >
                        <MenuItem value={"RazorPay"}>Online Payment</MenuItem>
                        <MenuItem value={"COD"}>Cash On Delivery</MenuItem>
    
                    </Select>
                    </FormControl>
                </>
            )}
        </div>
    );
}

function CartLeft({step, setStep, setCheckoutData}){

    const [myinfo_data, setinfo] = React.useState({
        name: "",
        surname: "",
        email: ""
    });

    const [userData, setUserData] = React.useState(null);
    const [billingData, setBillingData] = React.useState(null);
    const [selectedBillingAddress, setSelectedBillingAddress] = React.useState(null);
    const [deliveryData, setDeliveryData] = React.useState(null);
    const [paymentMethod, setPaymentMethod] = React.useState("RazorPay");

    // Update the parent component with all data
    React.useEffect(() => {
        setCheckoutData({
            myinfo: myinfo_data,
            selectedBillingAddress: selectedBillingAddress,
            deliveryData: deliveryData,
            paymentMethod: paymentMethod
        });
    }, [myinfo_data, selectedBillingAddress, deliveryData, paymentMethod]);

    return(
        <div className="cart_info_left leftCheckout">
            <MyInfo step={step} setStep={setStep} setinfo={setinfo} myinfo_data={myinfo_data}/>
            <BillingAddress 
                step={step} 
                setStep={setStep} 
                myinfo_data={myinfo_data}
                userData={userData} 
                setUserData={setUserData}
                setBillingData={setBillingData}
                setSelectedBillingAddress={setSelectedBillingAddress}
            />
            <Delivery 
                step={step} 
                setStep={setStep}
                setDeliveryData={setDeliveryData}
            />
            <PaymentOption
                step={step} 
                setStep={setStep}
                setPaymentMethod={setPaymentMethod}
            />
        </div>
    );
}

function Centered(){

    const {price} = useParams() || 50;
    const [step, setStep] = React.useState(1);
    const [checkoutData, setCheckoutData] = React.useState({
        myinfo: null,
        userData: null,
        billingData: null,
        selectedBillingAddress: null,
        deliveryData: null
    });

    return(
        <div className="Checkout_div">
            <h1 className="font-bold text-xl font-serif">Checkout</h1>
            <div className="checkout_centered centedDivCart">
                <div className="Cart_info">
                    <CartLeft 
                        step={step} 
                        setStep={setStep} 
                        setCheckoutData={setCheckoutData}
                    />
                    <CartRight  
                        step={step} 
                        price={price}
                        checkoutData={checkoutData}
                    />
                </div>
            </div>
        </div>
    );
}

function Checkout(){
    const navigate = useNavigate();

    React.useEffect(() => {
        const checkLoginStatus = async () => {
            try {
                const response = await axios.get(`${baseUrl}api/auth/IsLoggedIn`, { withCredentials: true });
                // console.log(response.data); 
            } catch (err) {
                console.error("Error while checking login status:", err.response?.data || err.message);
                alert('Please Login first');
                navigate("/login");
            }
        };

        checkLoginStatus();
    }, []);


    React.useEffect(() => {
        document.title = "Jutexx | Checkout";
    }, []);

    
    return(
        <div className="error_page">
            <Navbar/>
            {/* <MainContentBanner/> */}
            <Centered/>
            <Footer/>
        </div>
    );
}

export default Checkout